import React, { useState } from "react";
import "./ContactForm.css";
import { useContent } from "./ContentContext";

const ContactForm = () => {
  const { content, loading } = useContent();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    company: "",
    subject: "",
    comments: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", form);
    alert("Form Submitted!");
  };

  if (loading || !content) {
    return <div className="contact-container" style={{ color: 'white' }}>Loading Contact Info...</div>;
  }

  const { contactPage } = content;

  return (
    <div className="contact-container">
      <br />
      <br />
      <br />
      <h1 className="contact-title"><br />{contactPage.title}</h1>


      <form className="form" onSubmit={handleSubmit}>
        <div className="contact-row">
          <input type="text" name="firstName" placeholder="First Name*" value={form.firstName} onChange={handleChange} required />
          <input type="text" name="lastName" placeholder="Last Name*" value={form.lastName} onChange={handleChange} required />
        </div>

        <div className="contact-row">
          <input type="text" name="phone" placeholder="Phone Number*" value={form.phone} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email Address" value={form.email} onChange={handleChange} />
        </div>

        <div className="contact-row">
          <input type="text" name="company" placeholder="Company Name*" value={form.company} onChange={handleChange} required />
          <input type="text" name="subject" placeholder="Subject*" value={form.subject} onChange={handleChange} required />
        </div>

        <textarea name="comments" placeholder="Comments" value={form.comments} onChange={handleChange} />

        <button className="submit-btn" type="submit">Submit</button>
      </form>

      <div className="company-info-sections">
        <div className="company-info-grid">
          {contactPage.locations.slice(0, 2).map((loc, idx) => (
            <div className="company-info-block" key={idx}>
              <p className="block-title"><b>{loc.title}</b></p>
              <p className="block-city">{loc.city}</p>
              <p className="block-address">{loc.address}</p>
              {loc.phone && <p><b>Phone:</b> {loc.phone}</p>}
              {loc.fax && <p><b>Fax:</b> {loc.fax}</p>}
            </div>
          ))}
        </div>

        <h2 className="global-presence-title">Global Presence</h2>
        <div className="company-info-grid global-grid">
          {contactPage.locations.slice(2).map((loc, idx) => (
            <div className="company-info-block" key={idx}>
              <p className="block-title"><b>{loc.title}</b></p>
              <p className="block-city">{loc.city}</p>
              <p className="block-address">{loc.address}</p>
              {loc.phone && <p><b>T:</b> {loc.phone}</p>}
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default ContactForm;
